import { writable } from "svelte/store";
const loadingOverlay = writable(false);
export default loadingOverlay;
